<template>
  <div class="report-fs">
    <!-- <div style="margin-top: 178px;" v-if="pathLogo == m"></div>
      <div style="margin-top: 35px;" v-if="pathLogo != m"></div>
      <div class="mlogo t-alignlogo">
        <img class="wlogo" :src="pathLogo" />
      </div> -->
    <h3 class="text-center fs-head-co">{{ allData.fullName }}</h3>
    <h3 class="text-center fs-head-co">{{ allData.shortName }}</h3>
    <!-- <h3 class="text-center fs-head">تقرير الموظفين المعنيين بالاحالة على التقاعد الاجتماعي لبلوغ السن القانونية لسنة {{
      vacationYear }}</h3> -->
    <!-- <h3 class="text-center fs-head"> {{ DepartmentId == "" ? "" : data[0].departmentName }}</h3> -->
    <h4 class="text-left" style="margin-left: 50px; direction: ltr">
      التاريخ : {{ convertToUi(new Date()) }}
    </h4>

    <div class="md-layout">
      <div class="md-layout-item">
        <md-card>
          <md-card-header
            style="margin-bottom: 30px"
            class="md-card-header-text md-card-header-green"
          >
            <div class="card-text">
              <h4 class="title">
                تقرير الموظفين المعنيين بالاحالة على التقاعد الاجتماعي لبلوغ
                السن القانونية لسنة {{ vacationYear }}
              </h4>
            </div>
          </md-card-header>

          <div style="margin-top: 10px; margin-bottom: 35px" class="marginTop">
            <md-card-content>
              <md-table class="paginated-table table-striped table-hover mt-25">
                <md-table-row>
                  <md-table-cell class="border-staffLists">ر.م</md-table-cell>

                  <md-table-cell class="border-staffLists">الاسم</md-table-cell>

                  <md-table-cell class="border-staffLists"
                    >الرقم الوظيفي</md-table-cell
                  >

                  <md-table-cell class="border-staffLists"
                    >الرقم الوطني</md-table-cell
                  >

                  <md-table-cell class="border-staffLists"
                    >الادارة</md-table-cell
                  >

                  <md-table-cell class="border-staffLists"
                    >تاريخ الميلاد</md-table-cell
                  >

                  <md-table-cell class="border-staffLists"
                    >تاريخ المباشرة</md-table-cell
                  >

                  <md-table-cell class="border-staffLists"
                    >الملاحظات</md-table-cell
                  >
                </md-table-row>
                <md-table-row v-for="(item, i) in data" :key="i">
                  <md-table-cell class="border-staffLists" md-label="الصنف">{{
                    i + 1
                  }}</md-table-cell>

                  <md-table-cell class="border-staffLists" md-label="الصنف">{{
                    item.employeeName
                  }}</md-table-cell>

                  <md-table-cell class="border-staffLists" md-label="الصنف">{{
                    item.jobNumber
                  }}</md-table-cell>

                  <md-table-cell class="border-staffLists" md-label="الصنف">{{
                    item.nationalNumber
                  }}</md-table-cell>

                  <md-table-cell class="border-staffLists" md-label="الصنف">{{
                    item.departmentName
                  }}</md-table-cell>

                  <md-table-cell class="border-staffLists" md-label="الصنف">{{
                    convert(item.birthDate)
                  }}</md-table-cell>

                  <md-table-cell class="border-staffLists" md-label="الصنف">{{
                    convert(item.startingDate)
                  }}</md-table-cell>

                  <md-table-cell
                    class="border-staffLists"
                    md-label="الصنف"
                    >{{
                  }}</md-table-cell>
                </md-table-row>
              </md-table>
            </md-card-content>
          </div>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
//  import { count } from "console";
import env from "../../../env";

export default {
  mounted() {},
  props: ["data", "pathLogo", "allData", "vacationYear"],
  data() {
    return {
      currentSort: "",
      currentSortOrder: "asc",
      m: env.mTop(),
    };
  },
  methods: {
    convert(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return (
          d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate()

          // +
          // " , "
          // +
          // d.getHours() +
          // ":" +
          // d.getMinutes()
        );
      } catch (error) {}
    },
    convertToUi(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return " - ";
        }
        return (
          d.getDate() + " - " + (d.getMonth() + 1) + " - " + d.getFullYear()

          // +
          // " , "
          // +
          // d.getHours() +
          // ":" +
          // d.getMinutes()
        );
      } catch (error) {}
    },
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/StaffLists";
</style>